/**
 *  Samelogic SDK contains the client that is required to run your Samelogic Projects in your product.
 *
 * The main entry point to samelogic.js is the {@link @samelogic/samelogic-js#Samelogic} class, which when instantiated with an appId,
 * will return an object that is ready to use. This object requires an init() method to be called for the client to start.
 *
 * @packageDocumentation
 */
import { Samelogic } from './Samelogic';
import { setupAsyncLoading } from './setupAsyncLoading';

// Export these so we can get docs generated
export { ElementEventProps, PageEventProps } from './workflows';

export * from './Samelogic';
export * from './models';

export default Samelogic;

setupAsyncLoading();
